import { useMemo as B, useState as j, useRef as R, useCallback as re, useEffect as v, useId as Re, useImperativeHandle as Le, useContext as D } from "react";
import { b as g, B as Z, c as de, E as be, U as $e, a as ue, P as ve, F as we, h as ke, i as ye, H as Ce, j as xe, C as je, R as me, g as pe, f as Ne, k as ae, l as Ee, T as Oe } from "./event-name.mjs";
import { p as h, d as A, g as Ie, s as Te, f as M, a as Fe } from "./config.mjs";
import { a as L, u as De, z as Se } from "./dom.mjs";
import { jsx as te, jsxs as Ge, Fragment as Ve } from "react/jsx-runtime";
import { E as G } from "./context.mjs";
import { g as ze, c as qe } from "./index3.mjs";
import Ue from "medium-zoom";
import We from "copy-to-clipboard";
import Ke from "markdown-it";
import Je from "markdown-it-image-figures";
import Ze from "markdown-it-sub";
import Be from "markdown-it-sup";
import { randomId as he } from "@vavt/util";
import { LRUCache as Xe } from "lru-cache";
const P = {
  hljs: `${h}-hljs`,
  hlcss: `${h}-hlCss`,
  prettier: `${h}-prettier`,
  prettierMD: `${h}-prettierMD`,
  cropperjs: `${h}-cropper`,
  croppercss: `${h}-cropperCss`,
  screenfull: `${h}-screenfull`,
  mermaidM: `${h}-mermaid-m`,
  mermaid: `${h}-mermaid`,
  katexjs: `${h}-katex`,
  katexcss: `${h}-katexCss`
}, Vt = (e, t) => {
  const { value: o, modelValue: n, onSave: c } = e, { editorId: a } = t, [s, u] = j({
    // 是否已编译成html
    buildFinished: !1,
    // 存储当前最新的html
    html: ""
  });
  v(() => {
    const i = (m) => {
      u(() => ({
        buildFinished: !0,
        html: m
      }));
    };
    return g.on(a, {
      name: Z,
      callback: i
    }), () => {
      g.remove(a, Z, i);
    };
  }, [a]), v(() => {
    const i = () => {
      if (c) {
        const m = new Promise((r) => {
          if (s.buildFinished)
            r(s.html);
          else {
            const l = (d) => {
              r(d), g.remove(a, Z, l);
            };
            g.on(a, {
              name: Z,
              callback: l
            });
          }
        });
        c(o || n || "", m);
      }
    };
    return g.on(a, {
      name: de,
      callback: i
    }), () => {
      g.remove(a, de, i);
    };
  }, [a, n, c, s.buildFinished, s.html, o]), v(() => {
    u((i) => ({
      ...i,
      buildFinished: !1
    }));
  }, [o, n]);
}, zt = (e) => {
  const { noPrettier: t, noUploadImg: o } = e;
  v(() => {
    const { editorExtensions: n, editorExtensionsAttrs: c } = A, a = t || !!n.prettier.prettierInstance, s = t || !!n.prettier.parserMarkdownInstance;
    if (!(o || !!n.cropper.instance)) {
      const { js: i = {}, css: m = {} } = c.cropper || {};
      L("link", {
        ...m,
        rel: "stylesheet",
        href: n.cropper.css,
        id: P.croppercss
      }), L("script", {
        ...i,
        src: n.cropper.js,
        id: P.cropperjs
      });
    }
    if (!a) {
      const { standaloneJs: i = {} } = c.prettier || {};
      L("script", {
        ...i,
        src: n.prettier.standaloneJs,
        id: P.prettier
      });
    }
    if (!s) {
      const { parserMarkdownJs: i = {} } = c.prettier || {};
      L("script", {
        ...i,
        src: n.prettier.parserMarkdownJs,
        id: P.prettierMD
      });
    }
  }, [t, o]);
}, qt = (e, t) => {
  v(() => (g.on(e, {
    name: be,
    callback: t
  }), () => {
    g.remove(e, be, t);
  }), [e, t]);
}, Ut = (e, t) => {
  const { editorId: o } = t, { onUploadImg: n } = e;
  v(() => {
    const c = (a, s) => {
      const u = (i) => {
        g.emit(o, me, "image", {
          desc: "",
          urls: i
        }), s == null || s();
      };
      n == null || n(a, u);
    };
    return g.on(o, {
      name: $e,
      callback: c
    }), () => {
      g.remove(o, $e, c);
    };
  }, [o, n]);
}, Wt = (e, t) => {
  const { toolbars: o = Fe, toolbarsExclude: n = [] } = e, { editorId: c } = t, [a, s] = j(!1);
  return v(() => {
    const i = (m) => {
      s(m === void 0 ? (r) => !r : m);
    };
    return g.on(c, {
      name: ue,
      callback: i
    }), () => {
      g.remove(c, ue, i);
    };
  }, [c]), B(() => !n.includes("catalog") && o.includes("catalog") && a, [a, o, n]);
};
let Ae = "";
const Kt = (e) => {
  const {
    theme: t = M.theme,
    preview: o = M.preview,
    htmlPreview: n = M.htmlPreview,
    pageFullscreen: c = M.pageFullscreen,
    previewTheme: a = M.previewTheme,
    codeTheme: s = M.codeTheme,
    language: u = M.language,
    codeStyleReverse: i = M.codeStyleReverse,
    codeStyleReverseList: m = M.codeStyleReverseList
  } = e, r = B(() => {
    const p = A.editorExtensions.highlight, T = A.editorExtensionsAttrs.highlight, { js: $ } = p, w = {
      ...Ie,
      ...p.css
    }, { js: y, css: C = {} } = T || {}, E = i && m.includes(a) ? "dark" : t, x = w[s] ? w[s][E] : Ie.atom[E], H = w[s] && C[s] ? C[s][E] : C.atom ? C.atom[E] : {};
    return {
      js: {
        src: $,
        ...y
      },
      css: {
        href: x,
        ...H
      }
    };
  }, [i, m, a, t, s]), l = B(() => {
    const p = {
      ...Te,
      ...A.editorConfig.languageUserDefined
    };
    return p[u] ? p[u] : Te["zh-CN"];
  }, [u]), [d, k] = j({
    pageFullscreen: c,
    fullscreen: !1,
    preview: o,
    htmlPreview: o ? !1 : n,
    previewOnly: !1
  }), f = R(d), b = re((p, T) => {
    k(($) => {
      const w = T === void 0 ? !$[p] : T, y = {
        ...$
      };
      switch (p) {
        case "preview": {
          y.htmlPreview = !1, y.previewOnly = !1;
          break;
        }
        case "htmlPreview": {
          y.preview = !1, y.previewOnly = !1;
          break;
        }
        case "previewOnly": {
          w ? !y.preview && !y.htmlPreview && (y.preview = !0) : (f.current.preview || (y.preview = !1), f.current.htmlPreview || (y.htmlPreview = !1));
          break;
        }
      }
      return f.current[p] = w, y[p] = w, y;
    });
  }, []);
  return v(() => {
    Ae = document.body.style.overflow;
  }, []), v(() => {
    d.pageFullscreen || d.fullscreen ? document.body.style.overflow = "hidden" : document.body.style.overflow = Ae;
  }, [d.pageFullscreen, d.fullscreen]), [r, l, d, b];
}, Jt = (e, t, o, n, c, a) => {
  const { editorId: s } = t;
  v(() => {
    g.emit(s, ve, n.pageFullscreen);
  }, [s, n.pageFullscreen]), v(() => {
    g.emit(s, we, n.fullscreen);
  }, [s, n.fullscreen]), v(() => {
    g.emit(s, ke, n.preview);
  }, [s, n.preview]), v(() => {
    g.emit(s, ye, n.previewOnly);
  }, [s, n.previewOnly]), v(() => {
    g.emit(s, Ce, n.htmlPreview);
  }, [s, n.htmlPreview]), v(() => {
    g.emit(s, xe, o);
  }, [o, s]), Le(e, () => ({
    on(i, m) {
      switch (i) {
        case "pageFullscreen": {
          g.on(s, {
            name: ve,
            callback(r) {
              m(r);
            }
          });
          break;
        }
        case "fullscreen": {
          g.on(s, {
            name: we,
            callback(r) {
              m(r);
            }
          });
          break;
        }
        case "preview": {
          g.on(s, {
            name: ke,
            callback(r) {
              m(r);
            }
          });
          break;
        }
        case "previewOnly": {
          g.on(s, {
            name: ye,
            callback(r) {
              m(r);
            }
          });
          break;
        }
        case "htmlPreview": {
          g.on(s, {
            name: Ce,
            callback(r) {
              m(r);
            }
          });
          break;
        }
        case "catalog": {
          g.on(s, {
            name: xe,
            callback(r) {
              m(r);
            }
          });
          break;
        }
      }
    },
    togglePageFullscreen(i) {
      c("pageFullscreen", i);
    },
    toggleFullscreen(i) {
      g.emit(s, je, i);
    },
    togglePreview(i) {
      c("preview", i);
    },
    togglePreviewOnly(i) {
      c("previewOnly", i);
    },
    toggleHtmlPreview(i) {
      c("htmlPreview", i);
    },
    toggleCatalog(i) {
      g.emit(s, ue, i);
    },
    triggerSave() {
      g.emit(s, de);
    },
    insert(i) {
      g.emit(s, me, "universal", { generate: i });
    },
    focus(i) {
      var m;
      (m = a.current) == null || m.focus(i);
    },
    rerender() {
      g.emit(s, pe);
    },
    getSelectedText() {
      var i;
      return (i = a.current) == null ? void 0 : i.getSelectedText();
    },
    resetHistory() {
      var i;
      (i = a.current) == null || i.resetHistory();
    },
    domEventHandlers(i) {
      g.emit(s, Ne, i);
    },
    execCommand(i) {
      g.emit(s, me, i);
    },
    getEditorView() {
      var i;
      return (i = a.current) == null ? void 0 : i.getEditorView();
    }
  }), [a, s, c]);
}, Zt = (e) => {
  const t = Re();
  return e.id || e.editorId || h + "-" + t.replaceAll(":", "");
}, Ye = (e, t) => {
  const { editorId: o } = D(G);
  v(() => e.noImgZoomIn ? void 0 : (() => {
    const c = document.querySelectorAll(
      `#${o}-preview img:not(.not-zoom):not(.medium-zoom-image)`
    ), a = Ue(c, {
      background: "#00000073"
    });
    return () => {
      a.detach();
    };
  })(), [o, t, e.noImgZoomIn, e.setting]);
}, Qe = (e, t, o) => {
  const { editorId: n, usedLanguageText: c, customIcon: a, rootRef: s } = D(G), { formatCopiedText: u = (i) => i } = e;
  v(() => {
    var i;
    e.setting.preview && ((i = s.current) == null || i.querySelectorAll(`#${n} .${h}-preview .${h}-code`).forEach((m) => {
      let r = -1;
      const l = m.querySelector(
        `.${h}-copy-button`
      );
      l && (l.onclick = (d) => {
        d.preventDefault(), clearTimeout(r);
        const f = (m.querySelector("input:checked + pre code") || m.querySelector("pre code")).textContent, b = We(u(f)), { text: p, successTips: T, failTips: $ } = c.copyCode, w = b ? T : $;
        l.dataset.isIcon ? l.dataset.tips = w : l.innerHTML = w, r = window.setTimeout(() => {
          l.dataset.isIcon ? l.dataset.tips = p : l.innerHTML = p;
        }, 1500);
      });
    }));
  }, [
    a,
    n,
    u,
    t,
    o,
    e.setting.preview,
    s,
    c.copyCode
  ]);
}, et = (e) => {
  const { highlight: t } = D(G), o = R(A.editorExtensions.highlight.instance), [n, c] = j(!!o.current);
  return v(() => {
    e.noHighlight || A.editorExtensions.highlight.instance || De("link", {
      ...t.css,
      rel: "stylesheet",
      id: P.hlcss
    });
  }, [t.css, e.noHighlight]), v(() => {
    e.noHighlight || o.current || L(
      "script",
      {
        ...t.js,
        id: P.hljs,
        onload() {
          o.current = window.hljs, c(!0);
        }
      },
      "hljs"
    );
  }, []), { hljsRef: o, hljsInited: n };
}, ne = new Xe({
  max: 1e3,
  // 缓存10分钟
  ttl: 6e5
}), tt = (e) => {
  const { theme: t, rootRef: o } = D(G), { noMermaid: n, sanitizeMermaid: c } = e, a = R(A.editorExtensions.mermaid.instance), [s, u] = j(-1), i = re(() => {
    ne.clear();
    const r = a.current;
    !n && r && (r.initialize(
      A.mermaidConfig({
        startOnLoad: !1,
        theme: t === "dark" ? "dark" : "default"
      })
    ), u((l) => l + 1));
  }, [n, t]);
  v(i, [i]), v(() => {
    var k, f;
    const { editorExtensions: r, editorExtensionsAttrs: l } = A;
    if (n || a.current)
      return;
    const d = r.mermaid.js;
    /\.mjs/.test(d) ? (L("link", {
      ...(k = l.mermaid) == null ? void 0 : k.js,
      rel: "modulepreload",
      href: d,
      id: P.mermaidM
    }), import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      d
    ).then((b) => {
      a.current = b.default, i();
    })) : L(
      "script",
      {
        ...(f = l.mermaid) == null ? void 0 : f.js,
        src: d,
        id: P.mermaid,
        onload() {
          a.current = window.mermaid, i();
        }
      },
      "mermaid"
    );
  }, [i, n]);
  const m = re(async () => {
    var r;
    if (!n && a.current) {
      const l = ((r = o.current) == null ? void 0 : r.querySelectorAll(`div.${h}-mermaid`)) || [], d = document.createElement("div"), k = document.body.offsetWidth > 1366 ? document.body.offsetWidth : 1366, f = document.body.offsetHeight > 768 ? document.body.offsetHeight : 768;
      d.style.width = k + "px", d.style.height = f + "px", d.style.position = "fixed", d.style.zIndex = "-10000", d.style.top = "-10000";
      let b = l.length;
      b > 0 && document.body.appendChild(d), await Promise.allSettled(
        Array.from(l).map((p) => (async ($) => {
          var y;
          let w = ne.get($.innerText);
          if (!w) {
            const C = he();
            let E = { svg: "" };
            try {
              E = await a.current.render(
                C,
                $.innerText,
                d
              ), w = await c(E.svg);
              const x = document.createElement("p");
              x.className = `${h}-mermaid`, x.setAttribute("data-processed", ""), x.innerHTML = w, (y = x.children[0]) == null || y.removeAttribute("height"), ne.set($.innerText, x.innerHTML), $.dataset.line !== void 0 && (x.dataset.line = $.dataset.line), $.replaceWith(x);
            } catch {
            }
            --b === 0 && d.remove();
          }
        })(p))
      );
    }
  }, [n, o, c]);
  return { mermaidRef: a, reRender: s, replaceMermaid: m };
}, nt = (e) => {
  const t = R(A.editorExtensions.katex.instance), [o, n] = j(!!t.current);
  return v(() => {
    if (e.noKatex || t.current)
      return;
    const { editorExtensions: c } = A;
    L(
      "script",
      {
        src: c.katex.js,
        id: P.katexjs,
        onload() {
          t.current = window.katex, n(!0);
        }
      },
      "katex"
    ), L("link", {
      rel: "stylesheet",
      href: c.katex.css,
      id: P.katexcss
    });
  }, [e.noKatex]), { katexRef: t, katexInited: o };
}, rt = (e, t) => {
  const o = e.renderer.rules.fence.bind(e.renderer.rules);
  e.renderer.rules.fence = (n, c, a, s, u) => {
    const i = n[c], m = i.content.trim();
    if (i.info === "mermaid") {
      let r;
      n[c].map && n[c].level === 0 && (r = n[c].map[0], n[c].attrSet("data-line", String(r)));
      const l = ne.get(m);
      return l ? `<p class="${h}-mermaid" ${r !== void 0 ? "data-line=" + r : ""} data-processed>${l}</p>` : `<div class="${h}-mermaid" ${r !== void 0 ? "data-line=" + r : ""} data-mermaid-theme=${t.themeRef.current}>${m}</div>`;
    }
    return o(n, c, a, s, u);
  };
}, se = (e, t) => {
  const o = e.attrs ? e.attrs.slice() : [];
  return t.forEach((n) => {
    const c = e.attrIndex(n[0]);
    c < 0 ? o.push(n) : (o[c] = o[c].slice(), o[c][1] += ` ${n[1]}`);
  }), o;
}, st = (e, t) => {
  const o = [
    { open: "$$", close: "$$" },
    { open: "$", close: "$" },
    { open: "\\[", close: "\\]" },
    { open: "\\(", close: "\\)" }
  ];
  let n, c, a;
  for (const s of o)
    if (e.src.startsWith(s.open, e.pos)) {
      const u = e.pos + s.open.length;
      for (n = u; (n = e.src.indexOf(s.close, n)) !== -1; ) {
        for (a = n - 1; e.src[a] === "\\"; )
          a -= 1;
        if ((n - a) % 2 === 1)
          break;
        n += s.close.length;
      }
      if (n === -1)
        return t || (e.pending += s.open), e.pos = u, !0;
      if (n - u === 0)
        return t || (e.pending += s.open + s.close), e.pos = u + s.close.length, !0;
      if (!t) {
        const i = e.src.slice(u, n);
        c = e.push("math_inline", "math", 0), c.markup = s.open, c.content = i;
      }
      return e.pos = n + s.close.length, !0;
    }
  return !1;
}, ot = (e, t, o, n) => {
  const c = [
    { open: "$$", close: "$$" },
    { open: "\\[", close: "\\]" }
  ];
  let a, s, u, i, m = !1, r = e.bMarks[t] + e.tShift[t], l = e.eMarks[t];
  for (const d of c)
    if (e.src.slice(r, r + d.open.length) === d.open && e.src.slice(l - d.close.length, l) === d.close) {
      if (r += d.open.length, a = e.src.slice(r, l), n)
        return !0;
      for (a.trim().slice(-d.close.length) === d.close && (a = a.trim().slice(0, -d.close.length), m = !0), u = t; !m && (u++, !(u >= o || (r = e.bMarks[u] + e.tShift[u], l = e.eMarks[u], r < l && e.tShift[u] < e.blkIndent))); )
        e.src.slice(r, l).trim().slice(-d.close.length) === d.close && (i = e.src.slice(0, l).lastIndexOf(d.close), s = e.src.slice(r, i), m = !0);
      e.line = u + 1;
      const k = e.push("math_block", "math", 0);
      return k.block = !0, k.content = (a && a.trim() ? a + `
` : "") + e.getLines(t + 1, u, e.tShift[t], !0) + (s && s.trim() ? s : ""), k.map = [t, e.line], k.markup = d.open, !0;
    }
  return !1;
}, it = (e, { katexRef: t }) => {
  const o = (c, a, s, u, i) => {
    const m = c[a], r = {
      attrs: se(m, [["class", `${h}-katex-inline`]])
    };
    if (t.current) {
      const l = t.current.renderToString(
        m.content,
        A.katexConfig({
          throwOnError: !1
        })
      );
      return `<span ${i.renderAttrs(r)} data-processed>${l}</span>`;
    } else
      return `<span ${i.renderAttrs(r)}>${m.content}</span>`;
  }, n = (c, a, s, u, i) => {
    const m = c[a], r = {
      attrs: se(m, [["class", `${h}-katex-block`]])
    };
    if (t.current) {
      const l = t.current.renderToString(
        m.content,
        A.katexConfig({
          throwOnError: !1,
          displayMode: !0
        })
      );
      return `<p ${i.renderAttrs(r)} data-processed>${l}</p>`;
    } else
      return `<p ${i.renderAttrs(r)}>${m.content}</p>`;
  };
  e.inline.ruler.before("escape", "math_inline", st), e.block.ruler.after("blockquote", "math_block", ot, {
    alt: ["paragraph", "reference", "blockquote", "list"]
  }), e.renderer.rules.math_inline = o, e.renderer.rules.math_block = n;
}, ct = (e, t) => {
  t = t || {};
  const o = 3, n = t.marker || "!", c = n.charCodeAt(0), a = n.length;
  let s = "", u = "";
  const i = (r, l, d, k, f) => {
    const b = r[l];
    return b.type === "admonition_open" ? r[l].attrPush([
      "class",
      `${h}-admonition ${h}-admonition-${b.info}`
    ]) : b.type === "admonition_title_open" && r[l].attrPush(["class", `${h}-admonition-title`]), f.renderToken(r, l, d);
  }, m = (r) => {
    const l = r.trim().split(" ", 2);
    u = "", s = l[0], l.length > 1 && (u = r.substring(s.length + 2));
  };
  e.block.ruler.before(
    "code",
    "admonition",
    (r, l, d, k) => {
      let f, b, p, T = !1, $ = r.bMarks[l] + r.tShift[l], w = r.eMarks[l];
      if (c !== r.src.charCodeAt($))
        return !1;
      for (f = $ + 1; f <= w && n[(f - $) % a] === r.src[f]; f++)
        ;
      const y = Math.floor((f - $) / a);
      if (y !== o)
        return !1;
      f -= (f - $) % a;
      const C = r.src.slice($, f), E = r.src.slice(f, w);
      if (m(E), k)
        return !0;
      for (b = l; b++, !(b >= d || ($ = r.bMarks[b] + r.tShift[b], w = r.eMarks[b], $ < w && r.sCount[b] < r.blkIndent)); )
        if (c === r.src.charCodeAt($) && !(r.sCount[b] - r.blkIndent >= 4)) {
          for (f = $ + 1; f <= w && n[(f - $) % a] === r.src[f]; f++)
            ;
          if (!(Math.floor((f - $) / a) < y) && (f -= (f - $) % a, f = r.skipSpaces(f), !(f < w))) {
            T = !0;
            break;
          }
        }
      const x = r.parentType, H = r.lineMax;
      return r.parentType = "root", r.lineMax = b, p = r.push("admonition_open", "div", 1), p.markup = C, p.block = !0, p.info = s, p.map = [l, b], u && (p = r.push("admonition_title_open", "p", 1), p.markup = C + " " + s, p.map = [l, b], p = r.push("inline", "", 0), p.content = u, p.map = [l, r.line - 1], p.children = [], p = r.push("admonition_title_close", "p", -1), p.markup = C + " " + s), r.md.block.tokenize(r, l + 1, b), p = r.push("admonition_close", "div", -1), p.markup = r.src.slice($, f), p.block = !0, r.parentType = x, r.lineMax = H, r.line = b + (T ? 1 : 0), !0;
    },
    {
      alt: ["paragraph", "reference", "blockquote", "list"]
    }
  ), e.renderer.rules.admonition_open = i, e.renderer.rules.admonition_title_open = i, e.renderer.rules.admonition_title_close = i, e.renderer.rules.admonition_close = i;
}, lt = (e, t) => {
  e.renderer.rules.heading_open = (o, n) => {
    var u;
    const c = o[n], a = ((u = o[n + 1].children) == null ? void 0 : u.reduce((i, m) => i + (["text", "code_inline", "math_inline"].includes(m.type) && m.content || ""), "")) || "", s = c.markup.length;
    return t.headsRef.current.push({
      text: a,
      level: s
    }), c.map && c.level === 0 && c.attrSet(
      "id",
      t.mdHeadingId(a, s, t.headsRef.current.length)
    ), e.renderer.renderToken(o, n, t);
  }, e.renderer.rules.heading_close = (o, n, c, a, s) => s.renderToken(o, n, c);
}, at = {
  copy: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy ${h}-icon"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>`,
  "collapse-tips": `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-left ${h}-icon"><circle cx="12" cy="12" r="10"/><path d="m14 16-4-4 4-4"/></svg>`
}, dt = (e, t) => typeof t[e] == "string" ? t[e] : at[e], ut = (e, t) => {
  const o = e.renderer.rules.fence, n = e.utils.unescapeAll, c = /\[(\w*)(?::([\w ]*))?\]/, a = /::(open|close)/, s = (l) => l.info ? n(l.info).trim() : "", u = (l) => {
    const d = s(l), [k = null, f = ""] = (c.exec(d) || []).slice(1);
    return [k, f];
  }, i = (l) => {
    const d = s(l);
    return d ? d.split(/(\s+)/g)[0] : "";
  }, m = (l) => {
    const d = l.info.match(a) || [], k = d[1] === "open" || d[1] !== "close" && t.codeFoldable && l.content.trim().split(`
`).length < t.autoFoldThreshold, f = d[1] || t.codeFoldable ? "details" : "div", b = d[1] || t.codeFoldable ? "summary" : "div";
    return { open: k, tagContainer: f, tagHeader: b };
  }, r = (l, d, k, f, b) => {
    if (l[d].hidden)
      return "";
    const p = t.usedLanguageTextRef.current.copyCode.text, T = t.customIconRef.current.copy || p, $ = !!t.customIconRef.current.copy, w = `<span class="${h}-collapse-tips">${dt("collapse-tips", t.customIconRef.current)}</span>`, [y] = u(l[d]);
    if (y === null) {
      const { open: S, tagContainer: _, tagHeader: Q } = m(l[d]), N = [["class", `${h}-code`]];
      S && N.push(["open", ""]);
      const oe = {
        attrs: se(l[d], N)
      };
      l[d].info = l[d].info.replace(a, "");
      const ie = o(l, d, k, f, b);
      return `
        <${_} ${b.renderAttrs(oe)}>
          <${Q} class="${h}-code-head">
            <div class="${h}-code-flag"><span></span><span></span><span></span></div>
            <div class="${h}-code-action">
              <span class="${h}-code-lang">${l[d].info.trim()}</span>
              <span class="${h}-copy-button" data-tips="${p}"${$ ? " data-is-icon=true" : ""}>${T}</span>
              ${_ === "details" ? w : ""}
            </div>
          </${Q}>
          ${ie}
        </${_}>
      `;
    }
    let C, E, x, H, z = "", q = "", F = "";
    const { open: X, tagContainer: U, tagHeader: W } = m(l[d]), Y = [["class", `${h}-code`]];
    X && Y.push(["open", ""]);
    const V = {
      attrs: se(l[d], Y)
    };
    for (let S = d; S < l.length && (C = l[S], [E, x] = u(C), E === y); S++) {
      C.info = C.info.replace(c, "").replace(a, ""), C.hidden = !0;
      const _ = `${h}-codetab-${t.editorId}-${d}-${S - d}`;
      H = S - d > 0 ? "" : "checked", z += `
        <li>
          <input
            type="radio"
            id="label-${h}-codetab-label-1-${t.editorId}-${d}-${S - d}"
            name="${h}-codetab-label-${t.editorId}-${d}"
            class="${_}"
            ${H}
          >
          <label
            for="label-${h}-codetab-label-1-${t.editorId}-${d}-${S - d}"
            onclick="this.getRootNode().querySelectorAll('.${_}').forEach(e => e.click())"
          >
            ${x || i(C)}
          </label>
        </li>`, q += `
        <div role="tabpanel">
          <input
            type="radio"
            name="${h}-codetab-pre-${t.editorId}-${d}"
            class="${_}"
            ${H}
            role="presentation">
          ${o(l, S, k, f, b)}
        </div>`, F += `
        <input
          type="radio"
          name="${h}-codetab-lang-${t.editorId}-${d}"
          class="${_}"
          ${H}
          role="presentation">
        <span class=${h}-code-lang role="note">${i(C)}</span>`;
    }
    return `
      <${U} ${b.renderAttrs(V)}>
        <${W} class="${h}-code-head">
          <div class="${h}-code-flag">
            <ul class="${h}-codetab-label" role="tablist">${z}</ul>
          </div>
          <div class="${h}-code-action">
            <span class="${h}-codetab-lang">${F}</span>
            <span class="${h}-copy-button" data-tips="${p}"${$ ? " data-is-icon=true" : ""}>${T}</span>
            ${U === "details" ? w : ""}
          </div>
        </${W}>
        ${q}
      </${U}>
    `;
  };
  e.renderer.rules.fence = r, e.renderer.rules.code_block = r;
}, _e = (e, t, o) => {
  const n = e.attrIndex(t), c = [t, o];
  n < 0 ? e.attrPush(c) : (e.attrs = e.attrs || [], e.attrs[n] = c);
}, mt = (e) => e.type === "inline", pt = (e) => e.type === "paragraph_open", ht = (e) => e.type === "list_item_open", ft = (e) => e.content.indexOf("[ ] ") === 0 || e.content.indexOf("[x] ") === 0 || e.content.indexOf("[X] ") === 0, gt = (e, t) => mt(e[t]) && pt(e[t - 1]) && ht(e[t - 2]) && ft(e[t]), bt = (e, t) => {
  const o = e[t].level - 1;
  for (let n = t - 1; n >= 0; n--)
    if (e[n].level === o)
      return n;
  return -1;
}, $t = (e) => {
  const t = new e("html_inline", "", 0);
  return t.content = "<label>", t;
}, vt = (e) => {
  const t = new e("html_inline", "", 0);
  return t.content = "</label>", t;
}, wt = (e, t, o) => {
  const n = new o("html_inline", "", 0);
  return n.content = '<label class="task-list-item-label" for="' + t + '">' + e + "</label>", n.attrs = [{ for: t }], n;
}, kt = (e, t, o) => {
  const n = new t("html_inline", "", 0), c = o.enabled ? " " : ' disabled="" ';
  return e.content.indexOf("[ ] ") === 0 ? n.content = '<input class="task-list-item-checkbox"' + c + 'type="checkbox">' : (e.content.indexOf("[x] ") === 0 || e.content.indexOf("[X] ") === 0) && (n.content = '<input class="task-list-item-checkbox" checked=""' + c + 'type="checkbox">'), n;
}, yt = (e, t, o) => {
  if (e.children = e.children || [], e.children.unshift(kt(e, t, o)), e.children[1].content = e.children[1].content.slice(3), e.content = e.content.slice(3), o.label)
    if (o.labelAfter) {
      e.children.pop();
      const n = "task-item-" + Math.ceil(Math.random() * (1e4 * 1e3) - 1e3);
      e.children[0].content = e.children[0].content.slice(0, -1) + ' id="' + n + '">', e.children.push(wt(e.content, n, t));
    } else
      e.children.unshift($t(t)), e.children.push(vt(t));
}, Ct = (e, t = {}) => {
  e.core.ruler.after("inline", "github-task-lists", (o) => {
    const n = o.tokens;
    for (let c = 2; c < n.length; c++)
      gt(n, c) && (yt(n[c], o.Token, t), _e(
        n[c - 2],
        "class",
        "task-list-item" + (t.enabled ? " enabled" : " ")
      ), _e(n[bt(n, c - 2)], "class", "contains-task-list"));
  });
}, xt = (e) => {
  e.core.ruler.push("init-line-number", (t) => (t.tokens.forEach((o) => {
    o.map && (o.attrs || (o.attrs = []), o.attrs.push(["data-line", o.map[0].toString()]));
  }), !0));
}, Et = (e, t) => {
  const {
    modelValue: o,
    sanitize: n,
    mdHeadingId: c,
    codeFoldable: a,
    autoFoldThreshold: s,
    noKatex: u,
    noMermaid: i,
    noHighlight: m,
    setting: r,
    onHtmlChanged: l,
    onGetCatalog: d
  } = e, { editorConfig: k, markdownItConfig: f, markdownItPlugins: b } = A, {
    editorId: p,
    language: T,
    showCodeRowNumber: $,
    theme: w,
    usedLanguageText: y,
    customIcon: C,
    rootRef: E
  } = D(G), x = R([]), H = R(w);
  v(() => {
    H.current = w;
  }, [w]);
  const z = R(y);
  v(() => {
    z.current = y;
  }, [y]);
  const q = R(C);
  v(() => {
    q.current = C;
  }, [C]);
  const { hljsRef: F, hljsInited: X } = et(e), { katexRef: U, katexInited: W } = nt(e), { reRender: Y, replaceMermaid: V } = tt(e), [S] = j(() => {
    const I = Ke({
      html: !0,
      breaks: !0,
      linkify: !0
    });
    f(I, {
      editorId: p
    });
    const ce = [
      {
        type: "image",
        plugin: Je,
        options: { figcaption: !0, classes: "md-zoom" }
      },
      {
        type: "admonition",
        plugin: ct,
        options: {}
      },
      {
        type: "taskList",
        plugin: Ct,
        options: {}
      },
      {
        type: "heading",
        plugin: lt,
        options: { mdHeadingId: c, headsRef: x }
      },
      {
        type: "code",
        plugin: ut,
        options: {
          editorId: p,
          usedLanguageTextRef: z,
          // showCodeRowNumber,
          codeFoldable: a,
          autoFoldThreshold: s,
          customIconRef: q
        }
      },
      {
        type: "sub",
        plugin: Ze,
        options: {}
      },
      {
        type: "sup",
        plugin: Be,
        options: {}
      }
    ];
    u || ce.push({
      type: "katex",
      plugin: it,
      options: { katexRef: U }
    }), i || ce.push({
      type: "mermaid",
      plugin: rt,
      options: { themeRef: H }
    }), b(ce, {
      editorId: p
    }).forEach((O) => {
      I.use(O.plugin, O.options);
    });
    const ge = I.options.highlight;
    return I.set({
      highlight: (O, K, Pe) => {
        if (ge) {
          const le = ge(O, K, Pe);
          if (le)
            return le;
        }
        let J;
        !m && F.current ? F.current.getLanguage(K) ? J = F.current.highlight(O, {
          language: K,
          ignoreIllegals: !0
        }).value : J = F.current.highlightAuto(O).value : J = S.utils.escapeHtml(O);
        const Me = $ ? ze(
          J.replace(/^\n+|\n+$/g, ""),
          O.replace(/^\n+|\n+$/g, "")
        ) : `<span class="${h}-code-block">${J.replace(/^\n+|\n+$/g, "")}</span>`;
        return `<pre><code class="language-${K}" language=${K}>${Me}</code></pre>`;
      }
    }), xt(I), I;
  }), [_, Q] = j(`_article-key_${he()}`), [N, oe] = j(() => (x.current = [], n(S.render(o)))), ie = B(() => (m || X) && (u || W), [X, W, m, u]), fe = R(!0), ee = re(() => {
    x.current = [];
    const I = n(S.render(o));
    oe(I);
  }, [S, o, n]);
  return v(() => {
    g.emit(p, Z, N), l == null || l(N), d == null || d(x.current), g.emit(p, ae, x.current);
  }, [p, N, _, d, l]), v(() => {
    r.preview && (V().then(() => {
      Se(
        E == null ? void 0 : E.current.querySelectorAll(`#${p} .${h}-mermaid`)
      );
    }), g.emit(p, ae, x.current));
  }, [p, V, E, r.preview]), v(() => {
    if (fe.current) {
      fe.current = !1;
      return;
    }
    const I = setTimeout(
      () => {
        ee();
      },
      t ? 0 : k.renderDelay
    );
    return () => {
      clearTimeout(I);
    };
  }, [ie, w, ee, T, t, k.renderDelay]), v(() => {
    V().then(() => {
      Se(E == null ? void 0 : E.current.querySelectorAll(`#${p} .${h}-mermaid`));
    });
  }, [p, N, _, Y, V, E]), v(() => {
    const I = () => {
      g.emit(p, ae, x.current);
    };
    return g.on(p, {
      name: Ee,
      callback: I
    }), () => {
      g.remove(p, Ee, I);
    };
  }, [p]), v(() => {
    const I = () => {
      Q(`_article-key_${he()}`), ee();
    };
    return g.on(p, {
      name: pe,
      callback: I
    }), () => {
      g.remove(p, pe, I);
    };
  }, [p, ee]), { html: N, key: _ };
}, He = {
  checked: {
    regexp: /- \[x\]/,
    value: "- [ ]"
  },
  unChecked: {
    regexp: /- \[\s\]/,
    value: "- [x]"
  }
}, It = (e, t) => {
  const { editorId: o, rootRef: n } = D(G);
  v(() => {
    var s;
    const c = ((s = n.current) == null ? void 0 : s.querySelectorAll(".task-list-item.enabled")) || [], a = (u) => {
      var k;
      u.preventDefault();
      const i = u.target.checked ? "unChecked" : "checked", m = (k = u.target.parentElement) == null ? void 0 : k.dataset.line;
      if (!m)
        return;
      const r = Number(m), l = e.modelValue.split(`
`), d = l[Number(r)].replace(
        He[i].regexp,
        He[i].value
      );
      e.previewOnly ? (l[Number(r)] = d, e.onChange(l.join(`
`))) : g.emit(o, Oe, r + 1, d);
    };
    return c.forEach((u) => {
      u.addEventListener("click", a);
    }), () => {
      c.forEach((u) => {
        u.removeEventListener("click", a);
      });
    };
  }, [o, t, e, n]);
}, Bt = (e) => {
  const { previewOnly: t = !1 } = e, { editorId: o, previewTheme: n, showCodeRowNumber: c } = D(G), { html: a, key: s } = Et(e, !!t);
  Qe(e, a, s), Ye(e, a), It(e, a);
  const u = B(() => /* @__PURE__ */ te(
    "div",
    {
      id: `${o}-preview`,
      className: qe([
        `${h}-preview`,
        `${n}-theme`,
        c && `${h}-scrn`
      ]),
      dangerouslySetInnerHTML: { __html: a }
    },
    s
  ), [o, a, s, n, c]);
  return /* @__PURE__ */ Ge(Ve, { children: [
    e.setting.preview && /* @__PURE__ */ te(
      "div",
      {
        id: `${o}-preview-wrapper`,
        className: `${h}-preview-wrapper`,
        children: u
      },
      "content-preview-wrapper"
    ),
    !t && e.setting.htmlPreview && /* @__PURE__ */ te(
      "div",
      {
        id: `${o}-html-wrapper`,
        className: `${h}-preview-wrapper`,
        children: /* @__PURE__ */ te("div", { className: `${h}-html`, children: a })
      },
      "html-preview-wrapper"
    )
  ] });
};
export {
  P as C,
  dt as S,
  Bt as a,
  Vt as b,
  zt as c,
  Ut as d,
  qt as e,
  Wt as f,
  Kt as g,
  Jt as h,
  Zt as u
};
